import {Component} from '@angular/core';

@Component({
  selector: 'myvf-ui-sticky-feed-action',
  templateUrl: './sticky-feed-action.component.html',
  styleUrls: ['./sticky-feed-action.component.scss']
})
export class StickyFeedActionComponent {
}
